import { gql } from "@apollo/client";

export const SEND_CREDENTIALS_TO_SUPER_ADMIN = gql`
  mutation SendCredentialsToSuperAdmin($school_id: String!) {
    sendCredentialsToSuperAdmin(school_id: $school_id)
  }
`;

export const SCHOOL_LOGO_UPLOAD = gql`
  mutation UploadSchoolLogo($image_data: String!, $school_id: String!) {
    uploadSchoolLogo(image_data: $image_data, school_id: $school_id)
  }
`;

export const GET_ALL_SCHOOLS = gql`
  query GetAllSchools(
    $page: Int
    $limit: Int
    $school_id: String
    $school_name: String
    $trustee_id: String
  ) {
    getallschool(
      page: $page
      limit: $limit
      school_id: $school_id
      school_name: $school_name
      trustee_id: $trustee_id
    ) {
      data {
        _id
        name
        edviron_id
        legal_details {
          structure
        }
        address {
          street
          city
          state
          pin
        }
        bank_details {
          account_number
          account_holder_name
          account_ifse_code
        }
        phone_number
        email_id
        logo_url
        school_type
        date_of_establishment
        student_count
        fee_collection_date
        late_fee_grace_period
        late_fee
        convenience_fee
        session_end_date
        fee_frequency
        convenience_fee_frequency
        createdAt
        updatedAt
        board
        affiliation_number
        state
        city
        pin_code
        address_line_1
        address_line_2
        onboarder_id
        affiliation_body
        fee_reminder_policy
        reminders_available_from
        prev_due_min_payment_policy_perc
        sms_rate
        whatsapp_rate
        trustee_id
        amount_collected
        average_fee
      }
      pagination {
        page
        limit
        total
        totalPages
      }
    }
  }
`;
export const GET_TOTAL = gql`
  query GetAllSchools {
    getallschool {
      pagination {
        total
      }
    }
  }
`;

export const GET_SCHOOL_BY_ID = gql`
  query GetAllSchools($school_id: String) {
    getallschool(school_id: $school_id) {
      data {
        _id
        name
        edviron_id
        legal_details {
          structure
        }
        address {
          street
          city
          state
          pin
        }
        bank_details {
          account_number
          account_holder_name
          account_ifse_code
        }
        phone_number
        email_id
        logo_url
        school_type
        date_of_establishment
        student_count
        fee_collection_date
        late_fee_grace_period
        late_fee
        convenience_fee
        session_end_date
        fee_frequency
        convenience_fee_frequency
        createdAt
        updatedAt
        board
        affiliation_number
        state
        city
        pin_code
        address_line_1
        address_line_2
        onboarder_id
        affiliation_body
        fee_reminder_policy
        reminders_available_from
        prev_due_min_payment_policy_perc
        sms_rate
        whatsapp_rate
        trustee_id
        amount_collected
        average_fee
      }
    }
  }
`;

export const GET_INSTITUTES_OPTION = gql`
  query GetAllSchools($page: Int, $limit: Int, $school_name: String) {
    getallschool(page: $page, limit: $limit, school_name: $school_name) {
      data {
        _id
        name
      }
      pagination {
        page
        limit
        total
        totalPages
      }
    }
  }
`;

export const GET_TRUSTEE = gql`
  query getAllTrustee($page: Int = 1, $pageSize: Int = 10, $search: String) {
    getAllTrustee(page: $page, pageSize: $pageSize, search: $search) {
      data {
        _id
        name
      }
      page
      pageSize
      totalPages
      totalItems
    }
  }
`;
